import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import useProfileDashboard from "../../services/Settings/useProfileDashboard";
import useAuthApi from "../../services/LandingPage/useAuthApi";
import frame_image from "../../images/profile-bg-image.png";
import frame from "../../images/LandingPageImage/Isancharr.svg";
import { ChevronDown, ChevronUp } from "lucide-react";

const SetUp = () => {
  const { addWhatsappCredentials } = useProfileDashboard();
  const { fetchSubscriptionDetails } = useAuthApi();

  const [userID, setUserID] = useState(null);
  const [haveSubscriptionPlan, setHaveSubscriptionPlan] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const [formData, setFormData] = useState({
    appID: "",
    businessID: "",
    token: "",
    phoneNoId: "",
  });

  const getSubscription = async (id) => {
    const res = await fetchSubscriptionDetails(id);

    if (res?.responseCode === "00") {
      setHaveSubscriptionPlan(true);
    } else {
      setHaveSubscriptionPlan(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.appID ||
      !formData.businessID ||
      !formData.token ||
      !formData.phoneNoId
    ) {
      toast.error("All fields are required");
      return;
    }

    const res = await addWhatsappCredentials({
      userid: userID,
      appId: formData.appID,
      businessAccId: formData.businessID,
      token: formData.token,
      phoneNoId: formData.phoneNoId,
    });

    if (res?.responseCode === "00") {
      toast.success("Credentials added");
      setShowForm(false);
    } else {
      toast.error("Something went wrong");
    }
  };

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const stepsData = [
    {
      title: "Let's get started",
      content:
        "Get a separate phone number specifically for your WhatsApp Business account. This keeps your personal and business chats separate, making it more professional. Just remember, choose a number that isn't already linked to another WhatsApp Business account.",
    },
    {
      title: "Complete the Integration on isanchaar",
      content:
        "Content for Phone and Display Name Verification section. Content for Phone and Display Name Verification section. Content for Phone and Display Name Verification section. Content for Phone and Display Name Verification section.",
    },
    {
      title: "Phone and display name verification",
      content:
        "Content for Phone and Display Name Verification section. Content for Phone and Display Name Verification section. Content for Phone and Display Name Verification section. Content for Phone and Display Name Verification section.",
    },
    {
      title: "Get credentials from Meta",
      content:
        "Content for Phone and Display Name Verification section. Content for Phone and Display Name Verification section. Content for Phone and Display Name Verification section. Content for Phone and Display Name Verification section.",
    },
    {
      title: "Register your account",
      content:
        "Content for Phone and Display Name Verification section. Content for Phone and Display Name Verification section. Content for Phone and Display Name Verification section. Content for Phone and Display Name Verification section.",
    },
  ];

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user"));

    if (user?.userid) {
      setUserID(user.userid);
      getSubscription(user.userid);
    }
  }, []);

  return (
    <>
    <ToastContainer />

    <div className="flex p-8 bg-white mt-5 montserrat-font-1">
      {/* LEFT PANEL */}
      <div className="w-1/3 bg-green-600 text-white p-8 flex flex-col justify-between rounded-lg montserrat-font-1">
        <div className="montserrat-font-1">
          <div className="p-4">
            <img src={frame} alt="" />
          </div>

          <h2 className="text-3xl font-semibold leading-snug mb-6">
            Few clicks away from Creating your Business
          </h2>

          <hr className="border-white/40 mb-6" />

          <p className="text-lg montserrat-font-2">
            Start your business in minutes. Save time & money
          </p>
        </div>

        <div className="flex justify-center montserrat-font-1">
          <div className="rounded-xl p-2">
            <img
              src={frame_image}
              alt="preview"
              height={320}
              width={320}
              style={{ objectFit: "cover" }}
            />
          </div>
        </div>
      </div>

      {/* RIGHT PANEL */}
      <div className="w-2/3 p-10 overflow-y-auto montserrat-font-1">
        {!showForm ? (
          <>
            <h2 className="text-xl font-semibold mb-6">
              Setup Meta Business Account
            </h2>

            {/* ACCORDION */}
            <div>
              {stepsData.map((item, index) => (
                <div
                  key={index}
                  className={`border rounded-lg p-4 my-3 transition-all montserrat-font-1 ${
                    openIndex === index
                      ? "bg-green-50 border-green-300"
                      : "bg-white"
                  }`}
                >
                  {/* HEADER */}
                  <div className="flex justify-between items-center montserrat-font-1">
                    <div className="font-medium">{item.title}</div>

                    <div
                      onClick={() => handleToggle(index)}
                      className="cursor-pointer bg-green-100 px-2 py-1 rounded"
                    >
                      {openIndex === index ? (
                        <ChevronUp size={18} />
                      ) : (
                        <ChevronDown size={18} />
                      )}
                    </div>
                  </div>

                  {/* CONTENT */}
                  {openIndex === index && (
                    <div className="pt-3 text-gray-600">{item.content}</div>
                  )}
                </div>
              ))}

              {/* BUTTON SAME AS YOUR LOGIC */}
              <div className="mt-4 montserrat-font-1">
                <button
                  className={`px-5 py-2 rounded ${
                    haveSubscriptionPlan
                      ? "bg-green-500 text-white"
                      : "bg-red-500 text-white"
                  }`}
                  onClick={() => {
                    if (haveSubscriptionPlan) {
                      setShowForm(true); // same as setFirstPage(false)
                    }
                  }}
                  disabled={!haveSubscriptionPlan}
                >
                  {haveSubscriptionPlan
                    ? "Already have credentials?"
                    : "Subscription plan required to proceed !"}
                </button>
              </div>
            </div>
          </>
        ) : (
          <>
            {/* HEADER */}
            <h2 className="text-2xl font-semibold text-gray-800 mb-2 montserrat-font-1">
              Already have credentials ?
            </h2>

            {/* SUBTITLE */}
            <div className="mb-6">
              <h3 className="text-lg font-semibold text-gray-800 mt-5 montserrat-font-1">
                Verification
              </h3>
              <p className="text-gray-500 text-sm mt-1 montserrat-font-2">
                Complete this form to verify your credentials.
              </p>
            </div>

            {/* FORM */}
            <form onSubmit={handleSubmit} className="space-y-5 montserrat-font-1">
              {/* App ID */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  App ID
                </label>
                <input
                  name="appID"
                  value={formData.appID}
                  onChange={handleChange}
                  placeholder="Enter App ID"
                  className="w-full border border-gray-300 p-3 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                />
              </div>

              {/* Business ID */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  WhatsApp Business Account ID
                </label>
                <input
                  name="businessID"
                  value={formData.businessID}
                  onChange={handleChange}
                  placeholder="Enter WhatsApp Business Account ID"
                  className="w-full border border-gray-300 p-3 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                />
              </div>

              {/* Token */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Token
                </label>
                <input
                  name="token"
                  value={formData.token}
                  onChange={handleChange}
                  placeholder="Enter Token"
                  className="w-full border border-gray-300 p-3 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                />
              </div>

              {/* Phone Number ID */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Phone number ID
                </label>
                <input
                  name="phoneNoId"
                  value={formData.phoneNoId}
                  onChange={handleChange}
                  placeholder="Enter Phone number ID"
                  className="w-full border border-gray-300 p-3 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                />
              </div>

              {/* DIVIDER */}
              <hr className="my-6" />

              {/* BUTTONS */}
              <div className="flex gap-4 montserrat-font-1">
                <button
                  type="button"
                  onClick={() => setShowForm(false)}
                  className="px-6 py-2 rounded-md bg-green-50 text-green-600 border border-green-200"
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="px-6 py-2 rounded-md bg-green-500 text-white"
                >
                  Submit
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
    </>
  );
};

export default SetUp;
